export function addTooltip(el: HTMLElement) {
  const text = el.dataset.tooltipText as string;
  const position = el.dataset.tooltipPosition;

  function makeTooltipElement(): HTMLDivElement {
    const div = document.createElement("div");
    div.className = `tooltip m-${position}`;
    const child = document.createElement("div");
    child.className = "content";
    child.innerText = text;
    div.appendChild(child);
    return div;
  }

  let tooltipEl: HTMLDivElement | null = null;

  el.addEventListener("mouseenter", () => {
    if (!tooltipEl) tooltipEl = makeTooltipElement();
    el.appendChild(tooltipEl);
  });

  el.addEventListener("mouseleave", () => {
    if (!tooltipEl) return;
    el.removeChild(tooltipEl);
    tooltipEl = null;
  });
}
